import DivisionListLoader from './DivisionListLoader.container';

export default DivisionListLoader;
